<template>
  <v-app id="login-home">
    <v-content>
      <transition mode="out-in">
        <router-view />
      </transition>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    metaInfo () {
      return {
        title: 'Workspace - log in',
      }
    },
  }
</script>

<style lang="scss">
  @import '@/styles/index.scss';
</style>
